import { z } from 'zod'

export const STRATALYST_REPORT_LIFECYCLE_CONTRACT_VERSION = '1.0.0' as const
export const stratalystReportLifecycleResponseSchema = z.unknown()
export type StratalystReportLifecycleResponse = z.infer<typeof stratalystReportLifecycleResponseSchema>
